import { AnalyticsBrowser } from '@segment/analytics-next';

const segmentWriteKey = 'c5q8f70hFBOY1gAcsuCAsZg4e8qHpSql';

export const analytics = AnalyticsBrowser.load({
  writeKey: segmentWriteKey,
});
